import Messagge from './index';
import Template from './Template';
import Tasks from './Tasks';

export default {
  path: '/home/message',
  component: Messagge,
  redirect: '/home/message/template',
  children: [
    { path: '/home/message/template', component: Template },
    { path: '/home/message/tasks', component: Tasks }
  ]
};
